import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=b23bca94"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=b23bca94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports